module.exports = __webpack_public_path__ + "static/media/Contoh-small.57f5c36a.JPG";